import { storeStateInStorage } from './utils'

export default {
  retheme: name => state => storeStateInStorage(state, {theme: name})
}
